// This is the Document Description tab

import React, { useContext, useEffect, useReducer } from 'react';
import { FormattedMessage, useIntl, IntlContext } from 'react-intl';
import { useFormikContext } from 'formik';
import { SelectFieldWithLabel, CheckboxWithLabelAndAnchorTag, TextFieldWithLabelAndCharCounter, SelectFieldWithLabelAndSpinner } from '../../../components/FormFields';
import { constants } from '../../../constants'

export default function DetailsTabBody(props) {
	const [, forceUpdate] = useReducer(x => x + 1, 0);
	const { messages } = useContext(IntlContext);
	const { values, setFieldTouched } = useFormikContext();
	
	const labels = {
		"sima.efiling.tab.document.typeOfSubmission.other.1.label"         : useIntl().formatMessage({id:"sima.efiling.tab.document.typeOfSubmission.other.1.label"}, {i: (chunks) => <i>{chunks}</i>})
		, "sima.efiling.tab.document.typeOfSubmission.other.3.label"       : useIntl().formatMessage({id:"sima.efiling.tab.document.typeOfSubmission.other.3.label"}, {i: (chunks) => <i>{chunks}</i>})
		, "sima.efiling.tab.document.typeOfSubmission.other.6.description" : useIntl().formatMessage({id:"sima.efiling.tab.document.typeOfSubmission.other.6.description"}, {i: (chunks) => <i>{chunks}</i>})
		, "sima.efiling.tab.document.typeOfSubmission.other.6.a"           : useIntl().formatMessage({id:"sima.efiling.tab.document.typeOfSubmission.other.6.a"}, {i: (chunks) => <i>{chunks}</i>})
		, "sima.efiling.tab.document.typeOfSubmission.other.1.a"           : useIntl().formatMessage({id:"sima.efiling.tab.document.typeOfSubmission.other.1.a"}, {i: (chunks) => <i>{chunks}</i>})
	}

	const { typeOfSubmissions } = props.codeTables;

	let activeProceedingsOptions = props.activeProceedings.current
	let relatedSubmissionsOptions = props.relatedSubmissions.current;

	useEffect(() => {
		const runGet = async () => {
			await props.getRelatedSubmissions(values);
			setFieldTouched("relatedSubmission", true, true);
			setFieldTouched("proceedingIdentifier", true, true);
		}
		if (values.typeOfSubmission === constants.typeOfSubmissions["Response to Disclosure-Related Deficiency Notice"] && values.proceedingIdentifier) {
			runGet();
		}
	}, [values.typeOfSubmission, values.proceedingIdentifier])

	for (let item of activeProceedingsOptions) {
		if (item.value === values.proceedingIdentifier) {
			values.proceedingLabelForReceipt = item.label;
			break; // get out of here because we found the corresponding proceeding label
		}
	}
	


	function errorDRD(type, prop, headerMessage, mouseEnterId, alertClassName, timerBarId) {
		
		return (
			<>
			  <div id="global-alerts-container" className="row">
			    <section className="global-alert">
			      <div id={mouseEnterId} onMouseEnter={() => {
			      	if(prop.duration !== -1) {				
			      		let msgObj=prop; 
			      		msgObj.duration=-1; 
			      		prop = msgObj;
			      		forceUpdate();	
			      	}
			      }}>
			        <section className={"alert "+alertClassName}>
			          <h3>
			            {headerMessage}!
			          </h3>
			          {prop.messages.map(function(msg, index) {
			          	return (
			          		<div key={type+"Msg-"+index}>{msg}</div>
			          	);
			          })}
			        </section>
			        <span id={timerBarId} className={"alert "+alertClassName+" alertTimerBar"} style={{width:'0%'}}></span>
			      </div>
			    </section>
			  </div>
			  <div class="form-group col-md-12 text-left row-magic" style={{height: "1rem"}}></div>
			</>
		);
	}
	
	return (
		<div className="form-group col-md-12 text-left row-magic">
		  <h2><FormattedMessage id="sima.document.title.1"/></h2>
		  <div style={{lineHeight: "40px"}} className="form-group col-md-12"><FormattedMessage id="sima.document.description.1" values={{strong: chunks => <strong>{chunks}</strong>}}/></div>			
		  <br />
		  <br />
		  <SelectFieldWithLabel id="typeOfSubmission" name="typeOfSubmission" required={true} label={messages["sima.type.of.submission"]}
		    options={[
		    	{value:null, label: messages["common.select..."]}
		    	, ...typeOfSubmissions
		    ]}
		  />
		  
		  {values.typeOfSubmission === constants.typeOfSubmissions.Other ? 
		  	<div>
		  	  <CheckboxWithLabelAndAnchorTag id="typeOfSubmissionOther" name="typeOfSubmissionOther" required={false} label={messages["sima.efiling.tab.document.typeOfSubmission.other"]} 
		  	    options={[
		  	    	{value:constants.otherSubmissionTypes["dumpingOrSubsidy"], required:false, label:labels["sima.efiling.tab.document.typeOfSubmission.other.1.label"], anchorTagHref:labels["sima.efiling.tab.document.typeOfSubmission.other.1.a"], anchorTagDesc:messages["sima.efiling.tab.document.typeOfSubmission.other.1.description"]}
		  	    	, {value:constants.otherSubmissionTypes["normalValueRepresentation"], required:false, label:messages["sima.efiling.tab.document.typeOfSubmission.other.2.label"], anchorTagHref:messages["sima.efiling.tab.document.typeOfSubmission.other.2.a"], anchorTagDesc:messages["sima.efiling.tab.document.typeOfSubmission.other.2.description"]}
		  	    	, {value:constants.otherSubmissionTypes["disclosureUndertaking"], required:false, label:labels["sima.efiling.tab.document.typeOfSubmission.other.3.label"], anchorTagHref:messages["sima.efiling.tab.document.typeOfSubmission.other.3.a"], anchorTagDesc:messages["sima.efiling.tab.document.typeOfSubmission.other.3.description"]}
		  	    	, {value:constants.otherSubmissionTypes["requestForDisclosure"], required:false, label:messages["sima.efiling.tab.document.typeOfSubmission.other.4.label"]}
		  	    	, {value:constants.otherSubmissionTypes["normalValueUpdate"], required:false, label:messages["sima.efiling.tab.document.typeOfSubmission.other.5.label"]}
		  	    	, {value:constants.otherSubmissionTypes["limitedDisclosureRequest"], required:false, label:messages["sima.efiling.tab.document.typeOfSubmission.other.6.label"], anchorTagHref:labels["sima.efiling.tab.document.typeOfSubmission.other.6.a"], anchorTagDesc:labels["sima.efiling.tab.document.typeOfSubmission.other.6.description"], extraDesc:messages["sima.efiling.tab.document.typeOfSubmission.other.6.description.2"]}
		  	    ]}
		  	  />
		  	</div>
		  	:<></>
		  }
		  {values.typeOfSubmission === constants.typeOfSubmissions["Response to Disclosure-Related Deficiency Notice"] ? 
		  	<div>
		  	  <SelectFieldWithLabelAndSpinner id="proceedingIdentifier" name="proceedingIdentifier" label={messages["sima.proceeding.identifier"]}
		  	    required={true}
		  	    options={[
		  	    	...activeProceedingsOptions
		  	    ]}
		  	  />
		  	  {values.proceedingIdentifier ?
		  	  	<>
		  	  	  <SelectFieldWithLabel id="relatedSubmission" name="relatedSubmission" label={messages["sima.related.submission"]} 
		  	  	    required={true}
		  	  	    options={[
		  	  	    	...relatedSubmissionsOptions
		  	  	    ]}
		  	  	  />
		  	  	  {values.proceedingIdentifier && relatedSubmissionsOptions.length === 1 ? 
		  	  	  	<div className="form-group col-md-12 magical-incantation">
		  	  	  	  {errorDRD("flashWarning", {duration:-1, messages:[<FormattedMessage id="sima.related.submission.notFound.new" />]}, <FormattedMessage id="globalAlert.warning" />, "mouse-enter-DRD-w", "alert-warning", "warningAlertTimerBar")}
		  	  	  	</div>
		  	  	  : 
		  	  	  	<></>
		  	  	  }
		  	  	</> 
		  	  	: <></>
		  	  }
		  	</div>
		  :<></>
		  }
		  
		  <div style={{height:"50px"}}></div>
		  
		  <TextFieldWithLabelAndCharCounter maxLength={200} name="subject" id="subject" charCount={values.subject} charCountId="home.details.characters.args" label={messages["sima.efiling.tab.document.subject"]} required={false}/>
		  
		  <div className="form-group col-md-12 magical-incantation"><FormattedMessage id="sima.document.description.3" values={{p: chunks => <p>{chunks}</p>, span: chunks => <span className="glyphicon glyphicon-new-window">{chunks}</span>, a1: chunks => <a href={messages["sima.document.description.a.1"]} target="_blank" rel="noreferrer">{chunks}</a>, a2: chunks => <a href={messages["sima.document.description.a.2"]} target="_blank" rel="noreferrer">{chunks}</a>}}/></div>
		  <div className="form-group col-md-12 magical-incantation"><FormattedMessage id="sima.document.description.6" values={{p: chunks => <p>{chunks}</p>}}/></div>
		  <div className="form-group col-md-12 magical-incantation">
		    <ul className="lst-spcd-2">
		      <li><a href={messages["sima.document.description.a.3"]} target="_blank" rel="noreferrer"><FormattedMessage id="sima.document.description.7" values={{p: chunks => <p>{chunks}</p>, i: chunks => <i>{chunks}</i>}}/> <span className="glyphicon glyphicon-new-window"></span></a></li>
		      <li><a href={messages["sima.document.description.a.4"]} target="_blank" rel="noreferrer"><FormattedMessage id="sima.document.description.8" values={{p: chunks => <p>{chunks}</p>, i: chunks => <i>{chunks}</i>}}/> <span className="glyphicon glyphicon-new-window"></span></a></li>
		    </ul>
		  </div>
		  <div className="form-group col-md-12 magical-incantation"><FormattedMessage id="sima.document.description.9" values={{p: chunks => <p>{chunks}</p>}}/></div>		
		</div>
	);
}

